import * as React from "react";

export const AboutPage = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="one-half column" style={{ marginTop: "25%" }}>
                    <h4>Application information</h4>
                    <p>Build #{build_info.buildVersion}</p>
                </div>
            </div>
        </div>
    );
};
